
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { formatDate, getLocaleId, DatePipe } from '@angular/common';

@Component({
  selector: 'app-ranking-tecnico-particular',
  templateUrl: './ranking-tecnico-particular.component.html',
  styleUrls: ['./ranking-tecnico-particular.component.css']
})
export class RankingTecnicoParticularComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,private service: UserService) { }

  tecnico;
  asignaciones = [];
  pipe = new DatePipe('en-US');

  ngOnInit() {
    this.activatedRoute.params.subscribe(d=>{
      this.service.getTecnico(d.id).subscribe(e=>{
        this.tecnico = e.tecnico;
        this.service.getAsignaciones(this.tecnico._id).subscribe(f=>{
          this.asignaciones = f.asignaciones.sort(function(a,b){ return (new Date(a.fecha).getTime())> (new Date(b.fecha).getTime())?-1:1 });
          this.asignaciones.forEach(x=> {  x.date = this.pipe.transform(new Date(x.fecha), "dd/MM/yyyy") })
          
          this.getChartData();
          this.getChartData2();
        })
      });
    })
  }



  chartColors = [ {backgroundColor: ['#00168999']}];


  chartOptions = {
    title: {
      text: 'Acumulado de puntos ult 30 días',
      display: true,
      fontColor: 'white'
    },
    responsive: true,
    legend : {
      labels : {
        fontColor : '#ffffff'  
      }
    },
    scales: {
      xAxes: [{
        stacked: true,
        ticks: {
          fontColor: 'white',  // x axe labels (can be hexadecimal too)
        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        }
      }],
      yAxes: [{
        stacked: false,
        ticks: {
          fontColor: 'white',  // y axes numbers color (can be hexadecimal too)
          callback: function(value) {if (value % 1 === 0) {return value;}},

        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        },
        scaleLabel: {
          display: true,
          labelString: 'Puntos',
          fontColor: 'white',  // y axe label color (can be hexadecimal too)
        }
      }]
    },
  };





  chartData;
  chartLabels = [];
  getChartData(){
    let today = new Date();
    this.chartData = [];
    let data = [];
    let count = 0;
    for(let i = 30; i>=0; i--){
      let date = new Date().setDate( today.getDate()-i);
      let label = this.pipe.transform(  date, "dd/MM/yyyy");
       let sum = this.asignaciones.filter(x=> x.date == label).reduce((sum, current) => sum + current.cantidad, 0);
        count = count + sum;
        data.push(count)
        this.chartLabels.push(label.substr(0,5));
        console.log(count + " "  + label);
        
    }
    this.chartData = [ { data: data, label: this.tecnico.nombre }];
    console.log(this.chartData);
    
  }




  chartOptions2 = {
    responsive: true,
    title: {
      text: 'Clasificación de puntos asignados',
      display: true,
      fontColor: 'white'
    },
    legend : {
      labels : {
        fontColor : '#ffffff'  
      }
    },
    scales: {
      xAxes: [{
        ticks: {
          fontColor: 'white',  // x axe labels (can be hexadecimal too)
        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        }
      }],
      yAxes: [{
        ticks: {
          fontColor: 'white',  // y axes numbers color (can be hexadecimal too)
          callback: function(value) {if (value % 1 === 0) {return value;}}
        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        },
        
      }]
    },
  };

  chartData2;
  chartLabels2 = [];
  chartColors2: any[] = [ {backgroundColor: ["","","",""] }];
  getChartData2(){
    this.chartData2 = [];
    let data = [];


    let sum = this.asignaciones.filter(x=> x.type == "T").reduce((sum, current) => sum + current.cantidad, 0);
    this.chartColors2[0].backgroundColor[0] = sum>0?'#77DD77':'#FF6961';
    data.push(sum);
    this.chartLabels2.push("Finalizados");
    
    sum = this.asignaciones.filter(x=> x.type == "R").reduce((sum, current) => sum + current.cantidad, 0);
    this.chartColors2[0].backgroundColor[1] = sum>0?'#77DD77':'#FF6961';
    data.push(sum);
    this.chartLabels2.push("Cliente");

    sum = this.asignaciones.filter(x=> x.type == "RA").reduce((sum, current) => sum + current.cantidad, 0);
    this.chartColors2[0].backgroundColor[2] = sum>0?'#77DD77':'#FF6961';
    data.push(sum);
    this.chartLabels2.push("Admin(T)");

    sum = this.asignaciones.filter(x=> x.type == "A").reduce((sum, current) => sum + current.cantidad, 0);
    this.chartColors2[0].backgroundColor[3] = sum>0?'#77DD77':'#FF6961';
    data.push(sum);
    this.chartLabels2.push("Admin");

    this.chartData2 = [ { data: data, label: this.tecnico.nombre }];

  }

  getType(t){
    switch(t){
      case "T":  return "Ticket finalizado";
      case "RA": return "Calificacion Admin";
      case "R":  return "Calificacion Cliente";
      case "A":  return "Extra Admin";
    }
  }

}
